import EmployeeStatusContainer from 'containers/employee-analytics/analytic-item/EmployeeStatusContainer'
import GenderDiversityContainer from 'containers/employee-analytics/analytic-item/GenderDiversityContainer'
import HappinessIndexContainer from 'containers/employee-analytics/analytic-item/HappinessIndexContainer'
import JobLevelContainer from 'containers/employee-analytics/analytic-item/JobLevelContainer'
import LeaveUtilizationContainer from 'containers/employee-analytics/analytic-item/LeaveUtilizationContainer'
import LengthOfServiceContainer from 'containers/employee-analytics/analytic-item/LengthOfServiceContainer'
import TurnoverContainer from 'containers/employee-analytics/analytic-item/TurnoverContainer'
import EmployeeProductivityContainer from 'containers/employee-analytics/analytic-item/EmployeeProductivityContainer'
import InternalMovementContainer from 'containers/employee-analytics/analytic-item/InternalMovementContainer'
import Employee9BoxPerformanceTrendContainer from 'containers/employee-analytics/analytic-item/Employee9BoxPerformanceTrendContainer'
import Employee9BoxTalentMatrixContainer from 'containers/employee-analytics/analytic-item/Employee9BoxTalentMatrixContainer'

export const EmployeeAnalytics = () => {
    return (
        <div className='h-screen w-full bg-neutral-10 p-4 space-y-4 text-sm'>
            <div className='grid grid-cols-4 gap-4'>
                <EmployeeStatusContainer />
                <LengthOfServiceContainer />
                <JobLevelContainer />
                <GenderDiversityContainer />
            </div>
            <div className='grid grid-cols-2 gap-4'>
                <TurnoverContainer />
                <LeaveUtilizationContainer />
            </div>
            <div className='grid grid-cols-2 gap-4'>
                <HappinessIndexContainer />
                <EmployeeProductivityContainer />
            </div>
            <InternalMovementContainer />
            <div className='grid grid-cols-2 gap-4'>
                <Employee9BoxPerformanceTrendContainer />
                <Employee9BoxTalentMatrixContainer />
            </div>
        </div>
    )
}
